import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-server-error';
export var ID = 'icon-server-error';
/* eslint-disable max-len */

export var SVGServerError = function SVGServerError() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 80 50"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-647.000000, -1070.000000)"
  }, React.createElement("g", {
    transform: "translate(100.000000, 972.000000)"
  }, React.createElement("g", {
    transform: "translate(436.000000, 99.000000)"
  }, React.createElement("g", {
    transform: "translate(112.000000, 0.000000)"
  }, React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0.0715605119",
    y: "0.169110073",
    width: "60.487783",
    height: "41.350488"
  }), React.createElement("path", {
    d: "M6.71977494,8.78934502 C7.67611217,8.78934502 8.45137667,8.01742218 8.45137667,7.06520709 C8.45137667,6.112992 7.67611217,5.34106916 6.71977494,5.34106916 C5.76343771,5.34106916 4.98817321,6.112992 4.98817321,7.06520709 C4.98817321,8.01742218 5.76343771,8.78934502 6.71977494,8.78934502 Z M6.71977494,22.5824485 C7.67611217,22.5824485 8.45137667,21.8105256 8.45137667,20.8583105 C8.45137667,19.9060955 7.67611217,19.1341726 6.71977494,19.1341726 C5.76343771,19.1341726 4.98817321,19.9060955 4.98817321,20.8583105 C4.98817321,21.8105256 5.76343771,22.5824485 6.71977494,22.5824485 Z M6.71977494,36.3755519 C7.67611217,36.3755519 8.45137667,35.6036291 8.45137667,34.651414 C8.45137667,33.6991989 7.67611217,32.9272761 6.71977494,32.9272761 C5.76343771,32.9272761 4.98817321,33.6991989 4.98817321,34.651414 C4.98817321,35.6036291 5.76343771,36.3755519 6.71977494,36.3755519 Z M1.79569844,0.168655367 L58.8352056,0.168655367 L58.8352056,0.168655367 C59.7874207,0.168655367 60.5593435,0.940578212 60.5593435,1.8927933 L60.5593435,12.2376209 L60.5593435,12.2376209 C60.5593435,13.189836 59.7874207,13.9617588 58.8352056,13.9617588 L1.79569844,13.9617588 L1.79569844,13.9617588 C0.843483357,13.9617588 0.0715605119,13.189836 0.0715605119,12.2376209 L0.0715605119,1.8927933 L0.0715605119,1.8927933 C0.0715605119,0.940578212 0.843483357,0.168655367 1.79569844,0.168655367 Z M1.79569844,13.9617588 L58.8352056,13.9617588 L58.8352056,13.9617588 C59.7874207,13.9617588 60.5593435,14.7336817 60.5593435,15.6858967 L60.5593435,26.0307243 L60.5593435,26.0307243 C60.5593435,26.9829394 59.7874207,27.7548623 58.8352056,27.7548623 L1.79569844,27.7548623 L1.79569844,27.7548623 C0.843483357,27.7548623 0.0715605119,26.9829394 0.0715605119,26.0307243 L0.0715605119,15.6858967 L0.0715605119,15.6858967 C0.0715605119,14.7336817 0.843483357,13.9617588 1.79569844,13.9617588 Z M1.79569844,27.7548623 L58.8352056,27.7548623 L58.8352056,27.7548623 C59.7874207,27.7548623 60.5593435,28.5267851 60.5593435,29.4790002 L60.5593435,39.8238278 L60.5593435,39.8238278 C60.5593435,40.7760429 59.7874207,41.5479657 58.8352056,41.5479657 L1.79569844,41.5479657 L1.79569844,41.5479657 C0.843483357,41.5479657 0.0715605119,40.7760429 0.0715605119,39.8238278 L0.0715605119,29.4790002 L0.0715605119,29.4790002 C0.0715605119,28.5267851 0.843483357,27.7548623 1.79569844,27.7548623 Z",
    stroke: "#A8A0A0",
    strokeWidth: "0.862068966",
    strokeLinecap: "square"
  }), React.createElement("path", {
    d: "M54.5454545,4.3065864 L54.5454545,9.82382778 L54.5454545,4.3065864 Z M51.0822511,4.3065864 L51.0822511,9.82382778 L51.0822511,4.3065864 Z M47.6190476,4.3065864 L47.6190476,9.82382778 L47.6190476,4.3065864 Z M44.1558442,4.3065864 L44.1558442,9.82382778 L44.1558442,4.3065864 Z",
    stroke: "#A8A0A0",
    strokeWidth: "0.862068966",
    strokeLinecap: "square"
  }), React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: "56.4502165",
    cy: "26.2068966",
    rx: "13.8528139",
    ry: "13.7931034"
  }), React.createElement("path", {
    d: "M58.5281385,34.0865517 C53.9594805,32.9993103 50.5627706,28.9068966 50.5627706,24.0248276 C50.5627706,19.78 53.1307359,16.1324138 56.8038095,14.5375862 L56.7965368,25.5551724 L65.1082251,25.5551724 L65.101645,14.5382759 C68.7747186,16.1331034 71.3419913,19.7803448 71.3419913,24.0248276 C71.3419913,28.9068966 67.9452814,32.9993103 63.3766234,34.0865517 L63.3766234,47.2955172 L58.5281385,47.2955172 L58.5281385,34.0865517 Z",
    stroke: "#A8A0A0",
    strokeWidth: "0.862068966",
    fill: "#FFFFFF",
    transform: "translate(60.952381, 30.916552) rotate(-45.000000) translate(-60.952381, -30.916552) "
  })))))));
};
/* eslint-disable max-len */

var ServerError = function ServerError(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGServerError
  });
};

ServerError.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default ServerError;